export const DynamicFormFieldType = {
  TEXT: 'TEXT',
  OPTION: 'OPTION',
  DATE: 'DATE',
  TIME: 'TIME',
  DATETIME: 'DATETIME',
  BOOLEAN: 'BOOLEAN',
  NUMERIC: 'NUMERIC',
};
